// extracted by mini-css-extract-plugin
module.exports = {"base":"8px","iconWrapper":"icon_iconWrapper__vA_zH"};